import { useEffect, useRef } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import FooterScrollReveal from './components/FooterScrollReveal'
import Home from './pages/Home02'
import Privacy from './pages/Privacy'
import Delete from './pages/Delete'
import Terms from './pages/Terms'

const GA_MEASUREMENT_ID = 'G-LCR9Y4BQJK'

function App() {
  const { pathname, search } = useLocation()
  const isMinimalHome = pathname === '/'
  const gaSkipInitialPageView = useRef(true)

  useEffect(() => {
    if (typeof window.gtag !== 'function') return
    if (gaSkipInitialPageView.current) {
      gaSkipInitialPageView.current = false
      return
    }
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: pathname + (search || ''),
    })
  }, [pathname, search])

  return (
    <div className="min-h-screen flex flex-col text-ink-900">
      {!isMinimalHome && <Header />}

      <main className={`${isMinimalHome ? '' : 'flex-grow pt-16 sm:pt-[74px]'}`}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/app-privacy" element={<Privacy />} />
          <Route path="/app-delete" element={<Delete />} />
          <Route path="/app-terms" element={<Terms />} />
        </Routes>
      </main>

      {isMinimalHome ? <FooterScrollReveal /> : <Footer />}
    </div>
  )
}

export default App
